import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import JsonDebug from '../ui-elements/JsonDebug'
import FooterNavButtonFrame from '../ui-elements/FooterNavButtonFrame'
import AddButton from '../formfields/AddButton'
import IndividualCategory from './IndividualCategory'
import { subscribe } from '../utils/pubsub'


type Props = {
}

function ManageChecklistCategories({
}: Props) {

    const {
        sendMessageToWebsocket,
        setShowModal,
        tableData,
    } = useContext(GlobalContext)

    const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
    const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})


    useEffect(() => {
        // align form fields with existing tableData
        if (tableData && tableData.ChecklistCategories) {
            setFormFields(tableData.ChecklistCategories)
        }
    }, [tableData])


    const checkIfNameAlreadyBeenUsed = (name: string, id: string, values: any) => {
        let hasItBeenUsed = false
        if (!values) {
            return hasItBeenUsed
        }
        Object.keys(values).forEach((key) => {
            const value = values[key]
            if (key !== id || id === null) {
                console.log(`checking if ${name} (${id}) has been used in ${value['DisplayName']} (${key})`)
                if (value['DisplayName'] === name) {
                    console.log('YES')
                    hasItBeenUsed = true
                } else {
                    console.log('NO')
                }
            }
        })
        return hasItBeenUsed
    }
    const addCategoryType = () => {
        const newId = `ct-${Date.now()}-${Math.floor(Math.random() * 1000)}`
        const newFormData = { ...formFields, [newId]: {} }
        setFormFields(newFormData)
    }



    const validate = () => {
        let isValid = true
        const newFormErrors: ObjectStringKeyAnyValue = {}

        // check if all categories have a valid and unique name
        Object.keys(formFields).forEach((categoryTypeId) => {
            const value = formFields[categoryTypeId]
            if (value['DisplayName'] && value['DisplayName'] !== '') {
                const hasItBeenUsed = checkIfNameAlreadyBeenUsed(value['DisplayName'], categoryTypeId, formFields)
                if (hasItBeenUsed) {
                    isValid = false
                    newFormErrors[`${categoryTypeId}-DisplayName`] = 'Category names must be unique'
                    return
                }
            }

            if (!value['DisplayName'] || value['DisplayName'] === '') {
                isValid = false
                newFormErrors[`${categoryTypeId}-DisplayName`] = 'Category name is required'
                return
            }
        })

        // check if all categories have at least one value
        Object.keys(formFields).forEach((categoryTypeId) => {
            const value = formFields[categoryTypeId]
            if (value['Values'] && Object.keys(value['Values']).length === 0) {
                isValid = false
                newFormErrors[`${categoryTypeId}-Values`] = 'Category must have at least one value'
            }
        })


        setFormErrors(newFormErrors)
        return isValid
    }


    const saveCategories = () => {
        const isValid = validate()
        if (isValid) {
            setShowModal({ "spinner": "Saving checklist categories..." })
            const payload = JSON.stringify({
                action: "checklists",
                subAction: "saveChecklistCategories",
                formFields: formFields
            })
            console.log(payload)
            const unsubscribe = subscribe("checklistCategoriesSavedResponse", data => {
                setShowModal(null)
                unsubscribe()
            })
            sendMessageToWebsocket(payload)
        }
    }


    return <div className={`flex flex-col items-center`}>
        <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 items-start`}>

            <h2 className={`text-3xl  font-bold font-righteous font-brandblue`}>Manage checklist categories</h2>

            <AddButton
                text={`Add category type`}
                onClick={addCategoryType}
            />



            {Object.keys(formFields).map((key, index) => {
                return <IndividualCategory
                    key={index}
                    categoryId={key}
                    formFields={formFields}
                    setFormFields={setFormFields}
                    checkIfNameAlreadyBeenUsed={checkIfNameAlreadyBeenUsed}
                    formErrors={formErrors}
                    setFormErrors={setFormErrors}
                />
            })}




            {/* <JsonDebug jsonobject={formFields} /> */}


        </div>

        <FooterNavButtonFrame>
            <Button
                text={`Back`}
                internalLinkUrl='/checklists'
                size={`big`}
                variant={`gray`}
            />

            <Button
                text={`Save`}
                onClick={saveCategories}
                size={`big`}
            />
        </FooterNavButtonFrame>
    </div>
}
export default ManageChecklistCategories